module.exports = __webpack_public_path__ + "img/Carl.a9a016c4.jpg";